import apiClient from './axios';

const leaveApi = {
  getAll: (page, pageSize, search) =>
    apiClient.get('/leave-management/', { params: { page, page_size: pageSize, search } })
      .then(res => res.data),

  create: (data) => {
    const payload = {
      leave_type: data.leave_type,
      leave_from: data.from_date,
      leave_to: data.to_date,
      leave_reason: data.reason,
    };
    return apiClient.post('/leave-management/', payload).then(res => res.data);
  },

  update: (id, data) => {
    const payload = {
      leave_type: data.leave_type,
      leave_from: data.from_date,
      leave_to: data.to_date,
      leave_reason: data.reason,
    };
    return apiClient.patch(`/leave-management/${id}/`, payload).then(res => res.data);
  },

  delete: (id) => apiClient.delete(`/leave-management/${id}/`).then(() => id),

  approve: (id, remarks = '') =>
    apiClient.post(`/leave-management/${id}/approve/`, { manager_remarks: remarks }).then(res => res.data),

  reject: (id, remarks) =>
    apiClient.post(`/leave-management/${id}/reject/`, { manager_remarks: remarks }).then(res => res.data),
  
cancel: (id, remarks = '') =>
  apiClient.post(`/leave-management/${id}/cancel/`, { remarks })
    .then(res => res.data),

  getLeaveMeta: () =>
    apiClient.options('/leave-management/').then(res => res.data),

    exportCsv: async () => {
    const response = await apiClient.get('/leave-management/export/', {
      responseType: 'blob',
    });
    return response.data; // Blob
  },

};

export default leaveApi;